import { Toolbar as BaseToolbar } from "@base-ui/react/toolbar";
import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import css from "./Toolbar.module.css";

const ToolbarRoot = React.forwardRef(
  (
    {
      orientation = "horizontal",
      disabled = false,
      loopFocus = true,
      className,
      children,
      ...rest
    },
    ref,
  ) => (
    <BaseToolbar.Root
      ref={ref}
      orientation={orientation}
      disabled={disabled}
      loopFocus={loopFocus}
      className={clsx(css.root, className)}
      {...rest}
    >
      {children}
    </BaseToolbar.Root>
  ),
);

ToolbarRoot.displayName = "ToolbarRoot";

ToolbarRoot.propTypes = {
  orientation: PropTypes.oneOf(["horizontal", "vertical"]),
  disabled: PropTypes.bool,
  loopFocus: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const ToolbarGroup = React.forwardRef(
  ({ disabled = false, className, children, ...rest }, ref) => (
    <BaseToolbar.Group
      ref={ref}
      disabled={disabled}
      className={className}
      {...rest}
    >
      {children}
    </BaseToolbar.Group>
  ),
);

ToolbarGroup.displayName = "ToolbarGroup";

ToolbarGroup.propTypes = {
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const ToolbarButton = React.forwardRef(
  (
    {
      disabled = false,
      focusableWhenDisabled = true,
      className,
      children,
      ...rest
    },
    ref,
  ) => (
    <BaseToolbar.Button
      ref={ref}
      disabled={disabled}
      focusableWhenDisabled={focusableWhenDisabled}
      className={className}
      {...rest}
    >
      {children}
    </BaseToolbar.Button>
  ),
);

ToolbarButton.displayName = "ToolbarButton";

ToolbarButton.propTypes = {
  disabled: PropTypes.bool,
  focusableWhenDisabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

const ToolbarLink = React.forwardRef(
  ({ className, children, ...rest }, ref) => (
    <BaseToolbar.Link ref={ref} className={className} {...rest}>
      {children}
    </BaseToolbar.Link>
  ),
);

ToolbarLink.displayName = "ToolbarLink";

ToolbarLink.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

const ToolbarSeparator = React.forwardRef(({ className, ...rest }, ref) => (
  <BaseToolbar.Separator
    ref={ref}
    className={clsx(css.separator, className)}
    {...rest}
  />
));

ToolbarSeparator.displayName = "ToolbarSeparator";

ToolbarSeparator.propTypes = {
  className: PropTypes.string,
};

const Toolbar = {
  Root: ToolbarRoot,
  Group: ToolbarGroup,
  Button: ToolbarButton,
  Link: ToolbarLink,
  Separator: ToolbarSeparator,
};

export default Toolbar;
